import { StablesHome } from "./StablesHome";

export const Stables = () => <StablesHome historyTab="all" />;

export { StablesHome } from "./StablesHome";
export { StablesDepositar } from "./StablesDepositar";
export { StablesHistorico } from "./StablesHistorico";
export { StablesComprar } from "./StablesComprar";
export { StablesVender } from "./StablesVender";
export { StablesSwap } from "./StablesSwap";
export { StablesSacar } from "./StablesSacar";
export { StablesLimits } from "./StablesLimits";
